(() => {
  if (customElements.get('kr-parts-upsell')) return;
  const root = window.Shopify?.routes?.root || '/';
  const cache = new Map();
  let unique = 0;
  const patterns = [['kit',/varaosapaketti|tarvikepaketti|huoltopaketti/i],['cleaner',/puhdistusaine|pesuaine|puhdistusneste/i],['bags',/pölypuss/i],['filters',/suodatin|suodatt/i],['mops',/moppi|moppaus|moppityyny/i],['brushes',/harja|harjo|puhdistusrulla/i]];
  const kind = title => patterns.find(([,test])=>test.test(title || ''))?.[0] || 'other';
  const normalized = keys => (Array.isArray(keys)?keys:[]).map(key=>String(key).trim().toLocaleLowerCase('fi'));
  const compatible = (keys,source,model) => {
    const candidate=normalized(keys), origin=normalized(source);
    if(!candidate.length || !origin.length)return false;
    if(model && !model.family)return normalized(model.keys).some(key=>origin.includes(key) && candidate.includes(key));
    return origin.every(key=>candidate.includes(key));
  };
  const urlFor = (path,section) => {
    const url=new URL(root+path,location.origin);
    if(section)url.searchParams.set('section_id',section);
    const preview=new URL(location.href).searchParams.get('preview_theme_id');
    if(preview)url.searchParams.set('preview_theme_id',preview);
    return url;
  };
  const read = async (url,signal) => {
    const key=String(url), hit=cache.get(key);
    if(hit && Date.now()-hit.time<60000)return hit.text;
    const response=await fetch(url,{credentials:'same-origin',signal});
    if(!response.ok)throw Error('Unavailable');
    const text=await response.text();
    if(cache.size>=30)cache.delete(cache.keys().next().value);
    cache.set(key,{text,time:Date.now()});
    return text;
  };
  class PartsUpsell extends HTMLElement {
    connectedCallback() {
      this.instance=++unique;
      this.version=0;
      this.ready=false;
      this.hide();
      this.onModel=()=>{this.version++;this.controller?.abort();this.hide();this.schedule()};
      this.onStorage=event=>{if(event.key==='kr-robot-v2' || event.key===null)this.onModel()};
      this.onPage=()=>this.schedule();
      window.addEventListener('kr:model-changed',this.onModel);
      window.addEventListener('storage',this.onStorage);
      window.addEventListener('pageshow',this.onPage);
      if(typeof subscribe==='function')this.unsubscribe=subscribe(PUB_SUB_EVENTS.cartUpdate,()=>this.schedule());
      const count=document.querySelector('#cart-icon-bubble .cart-count');
      if(count){this.cartObserver=new MutationObserver(()=>this.schedule());this.cartObserver.observe(count,{childList:true,characterData:true,subtree:true})}
      if(this.dataset.placement==='cart'){
        this.drawer=document.querySelector('#header__minicart .minicart__wrapper');
        this.openObserver=new MutationObserver(()=>{if(this.drawer.classList.contains('open')){this.ready=true;this.schedule()}else{this.ready=false;this.controller?.abort()}});
        if(this.drawer){this.openObserver.observe(this.drawer,{attributes:true,attributeFilter:['class']});this.ready=this.drawer.classList.contains('open')}
        this.schedule();
      }else{
        this.visibility=new IntersectionObserver(entries=>{if(entries.some(entry=>entry.isIntersecting)){this.ready=true;this.visibility.disconnect();this.schedule()}},{rootMargin:'400px'});
        this.visibility.observe(this.previousElementSibling);
      }
    }
    disconnectedCallback() {
      this.version++;
      this.controller?.abort();
      clearTimeout(this.timer);
      window.removeEventListener('kr:model-changed',this.onModel);
      window.removeEventListener('storage',this.onStorage);
      window.removeEventListener('pageshow',this.onPage);
      this.unsubscribe?.();this.cartObserver?.disconnect();this.openObserver?.disconnect();this.visibility?.disconnect();
    }
    schedule(){clearTimeout(this.timer);if(this.ready)this.timer=setTimeout(()=>this.update(),120)}
    hide(){this.hidden=true;const slot=this.closest('.kr-parts-cart-slot');if(slot){slot.classList.add('hidden-recommend');slot.classList.remove('open')}}
    async update(){
      this.controller?.abort();
      const controller=this.controller=new AbortController(),version=++this.version;
      const deadline=setTimeout(()=>controller.abort(),4500);
      try{
        const source=JSON.parse(this.querySelector('[data-kr-upsell-source]').textContent);
        if(!source.keys?.length){this.hide();return}
        let directory=[],id='';
        try{directory=JSON.parse(document.getElementById('kr-model-directory')?.textContent || '[]');id=window.krModelMemory?.read() || localStorage.getItem('kr-robot-v2') || ''}catch{}
        const model=directory.find(item=>item.id===id || item.legacyIds?.includes(id));
        if(model && !model.family && !normalized(model.keys).some(key=>normalized(source.keys).includes(key))){this.hide();return}
        const routeModel=model&&!model.family?model:directory.find(item=>!item.family && normalized(item.keys).includes(normalized(source.keys)[0]));
        const fetchCandidates=async fallback=>{
          const url=urlFor('collections/'+(!fallback&&routeModel?.handle?routeModel.handle:'robotti-imurien-tarvikkeet'),'kr-parts-candidates');
          if(fallback || !routeModel?.handle || routeModel.filtered)url.searchParams.set('filter.p.m.custom.malli',model&&!model.family?model.keys[0]:source.keys[0]);
          const html=await read(url,controller.signal);
          const text=new DOMParser().parseFromString(html,'text/html').querySelector('[data-kr-candidates]')?.textContent;
          return text?JSON.parse(text).products:[];
        };
        const basketPromise=fetch(urlFor('cart.js'),{credentials:'same-origin',signal:controller.signal}).then(r=>{if(!r.ok)throw Error('Cart unavailable');return r.json()});
        let [products,basket]=await Promise.all([fetchCandidates(false).catch(error=>{if(controller.signal.aborted)throw error;return []}),basketPromise]);
        if(!products.length && routeModel?.handle && !controller.signal.aborted)products=await fetchCandidates(true);
        const excluded=new Set([String(source.id),...basket.items.map(item=>String(item.product_id))]);
        const basketKinds=new Set(basket.items.map(item=>kind(item.product_title)).filter(value=>value!=='kit'));
        const included=patterns.filter(([value,test])=>value!=='kit' && test.test(source.contents || '')).map(([value])=>value);
        const groups=new Set();
        const candidates=products.filter(item=>!excluded.has(item.id) && compatible(item.keys,source.keys,model)).map(item=>({...item,kind:kind(item.title)}))
          .filter(item=>item.kind!=='other' && item.kind!==kind(source.title) && !basketKinds.has(item.kind))
          .sort((a,b)=>Number(included.includes(a.kind))-Number(included.includes(b.kind)))
          .filter(item=>{if(groups.has(item.kind))return false;groups.add(item.kind);return true}).slice(0,3);
        const chosen=(await Promise.all(candidates.map(async item=>{
          try{
            const html=await read(urlFor('products/'+item.handle,'kr-parts-card'),controller.signal);
            const card=new DOMParser().parseFromString(html,'text/html').querySelector('[data-kr-upsell-card]');
            return card && compatible(JSON.parse(card.dataset.models || '[]'),source.keys,model)?card:null;
          }catch{return null}
        }))).filter(Boolean);
        if(!this.isConnected || version!==this.version)return;
        if(controller.signal.aborted){this.hide();return}
        if(!chosen.length){this.hide();return}
        const target=this.querySelector('[data-kr-upsell-items]');
        const fragments=document.createDocumentFragment();
        chosen.forEach((card,index)=>{
          if(index===0 && this.dataset.placement!=='cart')card.classList.add('kr-upsell-top');
          if(this.dataset.placement==='cart'){
            card.classList.add('cart-upsell-item','w-full');
            card.querySelectorAll('button[name=add] .btn-action').forEach(label=>label.textContent='Lisää ostoskoriin');
          }
          const ids=new Map();
          card.querySelectorAll('[id]').forEach(el=>{const old=el.id;el.id=old+'-kr-'+this.instance;ids.set(old,el.id)});
          card.querySelectorAll('[for],[form],[aria-labelledby],[aria-controls]').forEach(el=>{
            for(const attr of ['for','form','aria-labelledby','aria-controls'])if(el.hasAttribute(attr))el.setAttribute(attr,el.getAttribute(attr).split(' ').map(id=>ids.get(id)||id).join(' '));
          });
          fragments.append(document.importNode(card,true));
        });
        target.replaceChildren(fragments);
        this.querySelector('.product-recommendations-heading b').textContent=this.dataset.placement==='cart'?'Täydennä tilaustasi yhteensopivilla tarvikkeilla':model&&!model.family?'Täydennä tilauksesi – varaosat mallille '+model.name:'Täydennä tilauksesi robottiisi sopivilla varaosilla';
        this.querySelector('[data-kr-upsell-context]').hidden=true;
        this.hidden=false;
        const slot=this.closest('.kr-parts-cart-slot');
        if(slot){slot.classList.remove('hidden-recommend');slot.classList.add('open')}
        if(typeof initLazyloadItem==='function')initLazyloadItem();
      }catch{if(version===this.version)this.hide()}
      finally{clearTimeout(deadline)}
    }
  }
  customElements.define('kr-parts-upsell',PartsUpsell);
})();
